<!--
商品详情页规格选择

使用说明：

<ProductDetailSku
 :product="{Product}"
 :sku="[{ProductSku}]"
 @onSkuChange="sku改变时回调"
 />

Product={
    img: '图片',
    name="'商品名称'",
    price="商品价格",
    sale="已兑换数量"
}

ProductSku={
  skuId: 0,
  name: 'Sku名称',
  enable: 是否启用，true/false
}


-->

<template>
<div class="sku-wrap">
  <div class="sku-static-box">
    <span class="sku-label">规格</span>
    <span class="sku-name" @click="showDialog()" v-if="selectedSku">{{selectedSku.name}}</span>
    <span class="sku-name" @click="showDialog()" v-else>未选择</span>
    <i class="icon icon-gray-arrow"></i>
  </div>
  <div class="sku-static-box" @click="showProcess">
    <span class="sku-label" >兑换流程</span>
    <i class="icon icon-gray-arrow"></i>
  </div>
  <div class="sku-static-box" @click="showRules">
    <span class="sku-label" >兑换规则</span>
    <i class="icon icon-gray-arrow"></i>
  </div>

  <div class="sku-float-box" v-show="ui.show">
    <div class="mask" @click="closeDialog"></div>
    <transition name="slideup">
      <div class="dialog" v-show="ui.show">
        <Icon class="icon-dialog-close" v-on:click.native="closeDialog" :img="require('../../assets/icon-address-close.png')" />
        <!-- 商品信息 -->
        <div class="info">
          <Icon class="img" :img="image | asProductImage" size="cover" />
          <div class="product-title">{{title}}</div>
          <div class="product-info">
            <span class="price-num">{{price}}</span>
            <span class="price-unit">{{prointUnit}}</span>
            <span class="sale" v-if="sale">{{sale}}人已兑换</span>
          </div>
        </div>

        <div class="form-wrap">

          <!-- 规格信息 -->
          <Sku ref="skuList" :sku="sku" @onChange="onSkuChange" />

        </div>

        <ActionButton text="确定" @click="closeDialog" />
      </div>
    </transition>
  </div>
  <tips v-if="isModalShow" @close="closeModal" :type="type"></tips>
</div>
</template>

<script>
import $ from "jquery";
import api from "../../api";
import Sku from "@/components/products/form/Sku";
import ActionButton from "@/components/products/form/ActionButton";
import tips from '@/components/common/Modal/tips'


export default {
  props: ["sku", "product"],
  components: {
    Sku,
    ActionButton,
    tips
  },
  data() {
    return {
      type: '',
      isModalShow: false,
      selectedSku: null,
      image: this.product.image,
      title: this.product.title,
      price: this.product.price,
      sale: this.product.sale,
      prointUnit: api.store.loginedUser.config.pointName,
      ui: {
        show: false
      },
    };
  },
  methods: {
    showDialog() {
      this.ui.show = true;
      $("body").addClass("frozen");
    },
    closeModal() {
        this.isModalShow = false
        $("body").removeClass("frozen");
    },
    showProcess () {
      $("body").addClass("frozen");
      this.isModalShow = true;
      this.type = 1
    },
    showRules () {
      $("body").addClass("frozen");
      this.isModalShow = true;
      this.type = 2
    },
    closeDialog() {
      this.ui.show = false;
      $("body").removeClass("frozen");
    },
    setCurrSku(skuId) {
      this.sku.forEach(s => {
        if (skuId == s.skuId) {
          this.selectedSku = s;
          this.$refs.skuList.select(s);
          this.$emit("onSkuChange", this.selectedSku);
        }
      });
    },
    onSkuChange(sku) {
      this.selectedSku = sku;
      console.log(sku);
      this.title = sku.title;
      this.image = sku.image;
      this.price = sku.price;
      this.sale = sku.sale;
      this.$emit("onSkuChange", this.selectedSku);
    }
  }
};
</script>

<style lang="less" scoped>
.sku-static-box {
  background: #fff;
  margin-top: 1.06vw;
  font-size: 3.46vw;
  padding: 4vw 4vw;
  vertical-align: middle;
  .sku-label {
    display: inline-block;
    color: #999;
    vertical-align: top;
    margin-right: 4vw;
  }
  .sku-name {
    display: inline-block;
    color: #333;
    width: 76.4vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: top;
  }
  .icon-gray-arrow {
    float: right;
    background-image: url(../../assets/icon-product-arrow.png);
    width: 2.4vw;
    height: 2.4vw;
    margin-top: 1.06vw;
  }
}

.sku-float-box {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  .mask {
    position: absolute;
    z-index: 11;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #000;
    opacity: 0.6;
  }
  .dialog {
    position: fixed;
    z-index: 12;
    // top: 40.53vw;
    height: 120vw;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f2f2f2;
    border-top: 0.266vw solid #6c7177;
  }
  .icon-dialog-close {
    width: 2.8vw;
    height: 2.8vw;
    position: absolute;
    z-index: 13;
    top: 4.9vw;
    right: 4vw;
  }
  .info {
    height: 32.8vw;
    background: #fff;
    .img {
      width: 28.666vw;
      height: 28.666vw;
      border: 0.53vw solid #fff;
      outline: 0.266vw solid #6c7177;
      position: absolute;
      left: 4.3vw;
      top: -4vw;
    }
    .product-title {
      position: absolute;
      z-index: 13;
      left: 38.4vw;
      top: 4.9vw;
      width: 48vw;
      font-size: 3.46vw;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      line-height: 1.5em;
      height: 3em;
    }
    .product-info {
      position: absolute;
      z-index: 13;
      left: 38.4vw;
      top: 18.66vw;
      font-size: 3.6vw;
      .price-num,
      .price-unit {
        display: inline-block;
        color: @themeColor;
      }
      .sale {
        display: inline-block;
        margin-left: 2.933vw;
        color: #999;
      }
    }
  }
  .form-wrap {
    overflow-y: auto;
    height: 68vw;
    padding-bottom: 17vw;
  }
}
</style>






// WEBPACK FOOTER //
// src/components/products/ProductDetailForm.vue